var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticStyle: { width: "100%", padding: "40px 0 20px 0" } },
    [
      _c("div", { staticClass: "container" }, [
        _c(
          "div",
          {
            staticStyle: { width: "100%", height: "100%", position: "relative" }
          },
          [
            _c("div", { staticClass: "template" }, [
              _c("div", { staticClass: "title" }, [
                _vm._v(
                  "\n          衡水市" +
                    _vm._s(_vm.dimension.stageName) +
                    "学生综合素质评价报告单\n        "
                )
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticStyle: {
                    height: "20px",
                    "margin-top": "15px",
                    "text-align": "center",
                    "font-size": "0.9vw"
                  }
                },
                [
                  _vm.dimension.schoolName
                    ? _c("span", [
                        _vm._v("\n            学校"),
                        _c("u", [
                          _vm._v("  " + _vm._s(_vm.dimension.schoolName) + "  ")
                        ]),
                        _vm._v("\n            班级"),
                        _c("u", [
                          _vm._v("  " + _vm._s(_vm.dimension.className) + "  ")
                        ])
                      ])
                    : _c("span", [
                        _vm._v("\n            学校"),
                        _c("u", [_vm._v("    ")]),
                        _vm._v(" 班级"),
                        _c("u", [_vm._v("    ")])
                      ]),
                  _vm._v(" "),
                  _vm.dimension.schoolName
                    ? _c("span", { staticStyle: { float: "right" } }, [
                        _c("u", [
                          _vm._v(
                            "  " + _vm._s(_vm.dimension.schoolYearName) + "  "
                          )
                        ]),
                        _vm._v("学年\n            第\n            "),
                        _c("u", [
                          _vm._v(
                            "  " + _vm._s(_vm.dimension.schoolTermName) + "  "
                          )
                        ]),
                        _vm._v("学期\n          ")
                      ])
                    : _c("span", { staticStyle: { float: "right" } }, [
                        _c("u", [_vm._v("    ")]),
                        _vm._v("学年 第 "),
                        _c("u", [_vm._v("  ")]),
                        _vm._v("学期\n          ")
                      ])
                ]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "table-container" }, [
                _c("table", { attrs: { cellpadding: "6" } }, [
                  _c("tr", [
                    _c("td", { attrs: { colspan: "2" } }, [_vm._v("姓名")]),
                    _vm._v(" "),
                    _c("td", { attrs: { colspan: "2" } }, [
                      _vm._v(_vm._s(_vm.dimension.studentName))
                    ]),
                    _vm._v(" "),
                    _c("td", { attrs: { colspan: "2" } }, [_vm._v("性别")]),
                    _vm._v(" "),
                    _c("td", { attrs: { colspan: "2" } }, [
                      _vm._v(_vm._s(_vm.dimension.gender))
                    ]),
                    _vm._v(" "),
                    _c("td", { attrs: { colspan: "2" } }, [_vm._v("民族")]),
                    _vm._v(" "),
                    _c("td", { attrs: { colspan: "2" } }, [
                      _vm._v(_vm._s(_vm.dimension.nation))
                    ])
                  ]),
                  _vm._v(" "),
                  _c("tr", [
                    _c("td", { attrs: { colspan: "2" } }, [_vm._v("学籍号")]),
                    _vm._v(" "),
                    _c("td", { attrs: { colspan: "10" } }, [_vm._v(_vm._s(""))])
                  ]),
                  _vm._v(" "),
                  _c("tr", [
                    _c("td", { attrs: { colspan: "2" } }, [_vm._v("身份证号")]),
                    _vm._v(" "),
                    _c("td", { attrs: { colspan: "10" } }, [
                      _vm._v(_vm._s(_vm.dimension.idCard))
                    ])
                  ]),
                  _vm._v(" "),
                  _vm._m(0),
                  _vm._v(" "),
                  _c("tr", [
                    _c(
                      "td",
                      {
                        staticClass: "border-none-right",
                        attrs: { colspan: "2" }
                      },
                      [_vm._v("评价维度")]
                    ),
                    _vm._v(" "),
                    _c(
                      "td",
                      {
                        staticClass: "border-none-left",
                        staticStyle: { padding: "0" },
                        attrs: { colspan: "10", rowspan: "2" }
                      },
                      [
                        _c(
                          "table",
                          {
                            staticClass: "border-none",
                            staticStyle: {
                              height: "100%",
                              width: "100%",
                              margin: "0"
                            }
                          },
                          [
                            _c(
                              "tr",
                              {
                                staticClass: "border-none",
                                staticStyle: { height: "50%" }
                              },
                              _vm._l(_vm.dimension.indicatorsNames, function(
                                item
                              ) {
                                return _c(
                                  "td",
                                  {
                                    key: item,
                                    staticClass:
                                      "border-none border-left border-bottom"
                                  },
                                  [
                                    _vm._v(
                                      "\n                      " +
                                        _vm._s(item) +
                                        "\n                    "
                                    )
                                  ]
                                )
                              }),
                              0
                            ),
                            _vm._v(" "),
                            _c(
                              "tr",
                              { staticClass: "border-none" },
                              _vm._l(_vm.dimension.indicatorsValues, function(
                                item,
                                index
                              ) {
                                return _c(
                                  "td",
                                  {
                                    key: "indicatorsValues" + index,
                                    staticClass:
                                      "border-none border-left border-bottom"
                                  },
                                  [
                                    _vm._v(
                                      "\n                      " +
                                        _vm._s(item) +
                                        "\n                    "
                                    )
                                  ]
                                )
                              }),
                              0
                            )
                          ]
                        )
                      ]
                    )
                  ]),
                  _vm._v(" "),
                  _vm._m(1),
                  _vm._v(" "),
                  _c("tr", { staticStyle: { "max-height": "300px" } }, [
                    _vm._m(2),
                    _vm._v(" "),
                    _c(
                      "td",
                      {
                        staticStyle: { "text-align": "left" },
                        attrs: { colspan: "10" }
                      },
                      [
                        _vm._v(
                          "\n                " +
                            _vm._s(_vm.dimension.evalTeacher) +
                            "\n              "
                        )
                      ]
                    )
                  ]),
                  _vm._v(" "),
                  _c("tr", [
                    _c("td", { attrs: { rowspan: "2", colspan: "1" } }, [
                      _vm._v("自我评价")
                    ]),
                    _vm._v(" "),
                    _c("td", { attrs: { colspan: "1" } }, [_vm._v("肯定评价")]),
                    _vm._v(" "),
                    _c("td", { attrs: { colspan: "10" } }, [
                      _vm._v(_vm._s(_vm.dimension.evalSelf))
                    ])
                  ]),
                  _vm._v(" "),
                  _c("tr", [
                    _c("td", { attrs: { colspan: "1" } }, [_vm._v("差距评价")]),
                    _vm._v(" "),
                    _c("td", { attrs: { colspan: "10" } }, [
                      _vm._v(_vm._s(_vm.dimension.evalSelfGap))
                    ])
                  ]),
                  _vm._v(" "),
                  _vm._m(3)
                ])
              ])
            ])
          ]
        )
      ])
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("tr", [
      _c("td", { attrs: { colspan: "12" } }, [_vm._v("综合素质评价结果")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("tr", [
      _c("td", { staticClass: "border-none-right", attrs: { colspan: "2" } }, [
        _vm._v("评价结果")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", { attrs: { colspan: "2" } }, [
      _c(
        "span",
        {
          staticStyle: {
            "text-align": "center",
            display: "inline-block",
            width: "12px",
            "line-height": "1.4vw"
          }
        },
        [_vm._v("综合性评语")]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("tr", { staticStyle: { height: "5vw" } }, [
      _c("td", { attrs: { colspan: "3" } }, [_vm._v("班主任（签章）")]),
      _vm._v(" "),
      _c("td", { attrs: { colspan: "3" } }),
      _vm._v(" "),
      _c("td", { attrs: { colspan: "3" } }, [_vm._v("德育主任（签章）")]),
      _vm._v(" "),
      _c("td", { attrs: { colspan: "3" } })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-loader/node_modules/vue-hot-reload-api")      .rerender("data-v-2b1163ea", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-2b1163ea","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/components/common/TermTemplate.vue
// module id = null
// module chunks = 